// import React, { useCallback, useEffect } from "react";
// import { useRef } from "react";
// import { useState } from "react";
// import "./StudentApp.css";
// import little_image from "./Little_Logo150.png";
// import { GoLocation } from "react-icons/go";
// import { RiArrowDropDownLine } from "react-icons/ri";
// import { FiUpload } from "react-icons/fi";
// import { BsEyeFill } from "react-icons/bs";
// import loadingGif from "./loading-gif.gif";
// import Cropper from "react-cropper";
// import "cropperjs/dist/cropper.css";
// import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
// import Modal from "./ReviewPage/ReviewPageIndex";
// import StudentAddress from "./StudentAddress";
// import useHttp from "../../Hooks/use-http";

// // Material UI Components
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
//   Divider,
//   IconButton,
//   Avatar,
//   styled,
// } from "@mui/material";
// import { littleGreen, littleYellow } from "../CommonComponent/DefineColors";

// // Styled Components
// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   borderRadius: "12px",
//   boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     boxShadow: "0 12px 28px rgba(0,0,0,0.15)",
//   },
//   background: "linear-gradient(to bottom, #ffffff, #f9f9f9)",
// }));

// const SectionHeader = styled(Typography)(({ theme }) => ({
//   fontWeight: 600,
//   color: theme.palette.primary.main,
//   marginBottom: theme.spacing(3),
//   position: "relative",
//   "&:after": {
//     content: '""',
//     position: "absolute",
//     bottom: -8,
//     left: 0,
//     width: "50px",
//     height: "3px",
//     backgroundColor: theme.palette.primary.main,
//     borderRadius: "3px",
//   },
// }));

// const FormButton = styled(Button)(({ theme }) => ({
//   padding: theme.spacing(1.5),
//   borderRadius: "8px",
//   fontWeight: 600,
//   letterSpacing: "0.5px",
//   transition: "all 0.3s ease",
//   boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//   },
// }));

// const UploadButton = styled(Button)(({ theme }) => ({
//   border: `1px dashed ${theme.palette.primary.main}`,
//   backgroundColor: "rgba(25, 118, 210, 0.04)",
//   "&:hover": {
//     backgroundColor: "rgba(25, 118, 210, 0.08)",
//   },
// }));

// const defaultState = {
//   schoolNameError: "",
//   studentFirstNameError: "",
//   studentLastNameError: "",
//   studentClassError: "",
//   studentPhotoError: "",
//   parentFirstNameError: "",
//   parentLastNameError: "",
//   parentMobileNumberError: "",
//   parentEmailError: "",
//   addressError: "",
//   pincodeError: "",
//   areaError: "",
//   cityError: "",
//   stateError: "",
// };

// let img;
// let img_placeHolder = "Profile Photo";
// let valid = true;
// // let studentpickupAddress;
// // let studentdropAddress;
// // let pickupLatLng;
// // let dropLatLng;
// let riderData;
// let edit = new URLSearchParams(window.location.search)?.get("edit");
// let staffImg = "";
// let editPageImgFlag = 1;

// function App() {
//   const formRef = useRef();
//   const schoolNameRef = useRef();
//   const studentFirstNameRef = useRef();
//   const studentLastNameRef = useRef();
//   const studentPhotoRef = useRef();
//   const studentClassRef = useRef();
//   const parentFirstNameRef = useRef();
//   const parentLastNameRef = useRef();
//   const parentMobileNumberRef = useRef();
//   const parentEmailRef = useRef();
//   const addressRef = useRef();
//   const pincodeRef = useRef();
//   const cityInputRef = useRef();
//   const stateInputRef = useRef();
//   const areaInputRef = useRef();

//   const cropperRef = useRef(null);

//   const [error, setError] = useState(defaultState);
//   const [formIsValid, setFormIsValid] = useState();
//   const [stops, setStops] = useState([]);
//   const [isNearbyAddresses, setIsNearbyAddresses] = useState([]);
//   const [isPincodeChanged, setIsPincodeChanged] = useState(false);
//   const [isRender, setIsRender] = useState();
//   const [countryCode, setCountryCode] = useState("91");
//   const [type, setType] = useState("Employee");
//   const [showRadioButtons, setShowRadioButtons] = useState(true);
//   const [val, setVal] = useState();
//   const [myImg, setMyImg] = useState();
//   const [isStaffDetailApiCall, setIsStaffDetailApiCall] = useState(false);
//   const [departmentList, setDepartmentList] = useState(null);
//   const [selectedDepartment, setSelectedDepartment] = useState(null);
//   const [corpName, setCorpName] = useState("");
//   const [corpId, setCorpId] = useState("");
//   const [studentpickupAddress, setStudentpickupAddress] = useState("");
//   const [studentdropAddress, setStudentdropAddress] = useState("");
//   const [pickupLatLng, setPickupLatLng] = useState(null);
//   const [dropLatLng, setDropLatLng] = useState(null);
//   const [pincode, setPincode] = useState("");
//   const [formObj, setFormObj] = useState({
//     areaInput: "",
//     cityInput: "",
//     stateInput: "",
//     addressInput: "",
//   });

//   useEffect(() => {
//     const searchParams = new URLSearchParams(window.location.search);
//     setCorpName(searchParams.get("name") || "");
//     setCorpId(searchParams.get("corpId") || "");
//   }, []);

//   const corporateStopDetails = (data) => {
//     let temp = [];
//     temp.push({ StopName: "Custom" });
//     if (data.ShuttleStopList) {
//       let activeStops = data.ShuttleStopList.filter(
//         (st) => st.IsActive === true
//       );
//       temp.push(...activeStops);
//       setStops(temp);
//     }
//     setDepartmentList(data?.departmentLists);

//     if (data.ShuttleFor) {
//       const roles = data.ShuttleFor.split(",").map((role) =>
//         role.trim().toLowerCase()
//       );
//       if (roles.length === 0) {
//         setType("Employee");
//         setShowRadioButtons(true);
//       } else if (roles.length === 1) {
//         setType(roles[0] === "student" ? "Student" : "Employee");
//         setShowRadioButtons(false);
//       } else {
//         setType("Employee");
//         setShowRadioButtons(true);
//       }
//     } else {
//       setType("Employee");
//       setShowRadioButtons(true);
//     }
//     setIsStaffDetailApiCall(true);
//   };

//   const isFirstRender = useRef(true);
//   useEffect(() => {
//     if (isFirstRender.current) {
//       isFirstRender.current = false;
//       return;
//     }
//     if (edit) {
//       sendRequest(
//         {
//           url: "/student/getstaffdetails",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: sessionStorage.getItem("user"),
//             mobileNumber: edit,
//           },
//         },
//         authenticateUser
//       );
//     }

//     if (isPincodeChanged) {
//       var requestOptions = {
//         method: "GET",
//         redirect: "follow",
//       };

//       fetch(
//         `https://api.postalpincode.in/pincode/${isPincodeChanged}`,
//         requestOptions
//       )
//         .then((response) => response.text())
//         .then((result) => {
//           if (JSON.parse(result)[0]?.PostOffice)
//             setIsNearbyAddresses(JSON.parse(result)[0]?.PostOffice);
//           else setIsNearbyAddresses([{ Name: "No nearby address found" }]);
//         })
//         .catch((error) => console.log("error", error));
//       setIsPincodeChanged(false);
//     }
//   }, [isPincodeChanged, isStaffDetailApiCall]);

//   const nearbyAddressClickHandler = (e) => {
//     cityInputRef.current.value = isNearbyAddresses[e.target.id - 11].District;
//     stateInputRef.current.value = isNearbyAddresses[e.target.id - 11].Circle;
//     areaInputRef.current.value = isNearbyAddresses[e.target.id - 11].Name;
//     setIsNearbyAddresses([]);
//   };

//   const editPageFileViewHandler = () => {
//     if (val) viewDocument(val);
//   };

//   const viewDocument = (file) => {
//     let pdfWindow = window.open("");
//     pdfWindow.document.write(
//       "<html<head><title>" +
//         "document" +
//         "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>"
//     );
//     file.split(",")[0].includes("pdf")
//       ? pdfWindow.document.write(
//           "<body><embed width='50%' height='50%' src='data:application/pdf;base64, " +
//             encodeURI(file.split(",")[1]) +
//             "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>"
//         )
//       : pdfWindow?.document.write(
//           `<head><title>Document preview</title></head><body><img src="${file}" width="30%" height="50%" ></body></html >`
//         );
//   };

//   const authenticateUser = (data) => {
//     riderData = data.Staffdetails;
//     const addressParts =
//       riderData?.Address?.split(", ").map((part) => part.trim()) || [];

//     const Pin = addressParts[addressParts.length - 1] || "";
//     const State = addressParts[addressParts.length - 2] || "";
//     const City = addressParts[addressParts.length - 3] || "";
//     const Area =
//       addressParts.slice(0, addressParts.length - 3).join(", ") || "";

//     let otherDetails = data.Staffdetails?.OtherDetails;
//     areaInputRef.current.value = otherDetails.Area ?? Area;
//     stateInputRef.current.value = otherDetails.State ?? State;
//     cityInputRef.current.value = otherDetails.City ?? City;
//     pincodeRef.current.value = otherDetails.Pincode ?? Pin;
//     addressRef.current.value = riderData?.Address;
//     studentFirstNameRef.current.value = riderData?.FirstName;
//     studentLastNameRef.current.value = riderData?.LastName;
//     if (type !== "Student") {
//       studentClassRef.current.value = riderData?.MobileNumber.slice(2);
//       studentClassRef.current.disabled = true;
//     }
//     if (type === "Student") {
//       studentClassRef.current.value = otherDetails.Class;
//       parentFirstNameRef.current.value = otherDetails.ParentFirstName;
//       parentLastNameRef.current.value = otherDetails.ParentLastName;
//       parentMobileNumberRef.current.value = otherDetails.ParentsMobileNumber;
//       parentEmailRef.current.value = otherDetails?.ParentEmailAddress;
//       parentMobileNumberRef.current.value = riderData?.MobileNumber.slice(2);
//       parentMobileNumberRef.current.disabled = true;
//     }
//     // pickupLatLng = {
//     //   lat: +riderData?.PickupLL.split(",")[0],
//     //   lng: +riderData?.PickupLL.split(",")[1],
//     // };
//     // dropLatLng = {
//     //   lat: +riderData?.DropLL.split(",")[0],
//     //   lng: +riderData?.DropLL.split(",")[1],
//     // };
//     // studentpickupAddress = riderData?.PickupPoint;
//     // studentdropAddress = riderData?.DropPoint;
//     if (riderData?.PickupLL) {
//       const [lat, lng] = riderData.PickupLL.split(",").map(Number);
//       setPickupLatLng({ lat, lng });
//       setStudentpickupAddress(riderData?.PickupPoint || "");
//     }

//     if (riderData?.DropLL) {
//       const [lat, lng] = riderData.DropLL.split(",").map(Number);
//       setDropLatLng({ lat, lng });
//       setStudentdropAddress(riderData?.DropPoint || "");
//     }
//     staffImg = riderData?.RiderImage;
//     setVal(riderData?.RiderImage);
//   };

//   const { isLoading, sendRequest } = useHttp();

//   useEffect(() => {
//     if (corpId) {
//       sendRequest(
//         {
//           url: "/corporate",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               filter: {
//                 corporateID: corpId,
//               },
//             },
//           },
//         },
//         corporateStopDetails
//       );
//     }
//   }, [sendRequest, corpId]);

//   // const pincodeChangeHandler = (e) => {
//   //   if (e.target?.value.length > 5) {
//   //     setIsPincodeChanged(e.target?.value);
//   //     valid = true;
//   //     setError((prev) => ({ ...prev, pincodeError: "" }));
//   //   } else if (!e.target?.value) {
//   //     setIsNearbyAddresses(false);
//   //   }
//   // };
//   const pincodeChangeHandler = (e) => {
//     const value = e.target.value;
//     if (/^\d*$/.test(value) && value.length <= 6) {
//       // Limit to 6 digits
//       setPincode(value);
//       if (value.length === 6) {
//         setIsPincodeChanged(value);
//         setError((prev) => ({ ...prev, pincodeError: "" }));
//       }
//     }
//   };

//   const areaChangeHandler = () => {
//     if (areaInputRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, areaError: "" }));
//     }
//   };

//   const cityChangeHandler = () => {
//     if (cityInputRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, cityError: "" }));
//     }
//   };

//   const stateChangeHandler = () => {
//     if (stateInputRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, stateError: "" }));
//     }
//   };

//   const studentFirstNameChangeHandler = () => {
//     if (studentFirstNameRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, studentFirstNameError: "" }));
//     }
//   };

//   const studentLastNameChangeHandler = () => {
//     if (studentLastNameRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, studentLastNameError: "" }));
//     }
//   };

//   const studentClassChangeHandler = () => {
//     if (studentClassRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, studentClassError: "" }));
//     }
//   };

//   const studentPhotoChangeHandler = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const validTypes = ["image/jpeg", "image/jpg", "image/png"];
//     if (!validTypes.includes(file.type)) {
//       setError((prev) => ({
//         ...prev,
//         studentPhotoError: "Only JPG or PNG allowed.",
//       }));
//       return;
//     }

//     const localUrl = URL.createObjectURL(file);
//     setMyImg(localUrl);
//     editPageImgFlag = false;
//     setError((prev) => ({ ...prev, studentPhotoError: "" }));

//     let imageName = e.target?.value.split("fakepath")[1]?.split("\\")?.pop();
//     img_placeHolder = imageName;

//     const fileExtension = file.name.split(".").pop().toLowerCase();
//     const formDataUpload = new FormData();
//     formDataUpload.append("file", file);
//     formDataUpload.append("fileName", file.name);
//     formDataUpload.append("folderName", "rider");
//     formDataUpload.append("uniqueID", studentFirstNameRef.current?.value);
//     formDataUpload.append("documentID", "logo");
//     formDataUpload.append("fileExtension", fileExtension);

//     try {
//       const response = await fetch(
//         "https://littleinfinity.in:4001/documentfileupload",
//         {
//           method: "POST",
//           body: formDataUpload,
//         }
//       );

//       const data = await response.json();

//       if (response.ok) {
//         staffImg = data?.data;
//         alert("Picture uploaded successfully!");
//       } else {
//         console.error("Upload failed:", data.message);
//         setError((prev) => ({
//           ...prev,
//           studentPhotoError: "Upload failed. Try again.",
//         }));
//       }
//     } catch (err) {
//       console.error("Upload error:", err);
//       setError((prev) => ({
//         ...prev,
//         studentPhotoError: "Upload error. Try again.",
//       }));
//     }
//   };

//   const ParentFirstNameChangeHandler = () => {
//     if (parentFirstNameRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, parentFirstNameError: "" }));
//     }
//   };

//   const parentMobileChangeHandler = () => {
//     if (parentMobileNumberRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, parentMobileNumberError: "" }));
//     }
//   };

//   const parentLastNameChangeHanler = () => {
//     if (parentLastNameRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, parentLastNameError: "" }));
//     }
//   };

//   const parentEmailChangeHanlder = () => {
//     if (parentEmailRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, parentEmailError: "" }));
//     } else if (
//       !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(
//         parentEmailRef.current?.value
//       )
//     ) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         parentEmailError: "Please Enter Valid email",
//       }));
//     }
//   };

//   const addressChangeHandler = () => {
//     if (addressRef.current?.value) {
//       valid = true;
//       setError((prev) => ({ ...prev, addressError: "" }));
//     } else {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         addressError: "Please Enter Valid address",
//       }));
//     }
//   };

//   const resetClickHandler = () => {
//     valid = false;
//     formRef.current.reset();
//     img_placeHolder = "Only Upload Jpg/Png/Jpeg";
//     setError(defaultState);
//   };

//   const getAddress = useCallback((type, addressValue, lat, lng) => {
//     if (type === "pickup") {
//       setPickupLatLng({ lat: +lat, lng: +lng });
//       setStudentpickupAddress(addressValue);
//     } else {
//       setDropLatLng({ lat: +lat, lng: +lng });
//       setStudentdropAddress(addressValue);
//     }
//   }, []);

//   const submitCLickHandler = (event) => {
//     let studentPhotoPath = studentPhotoRef.current?.value;
//     edit
//       ? (studentPhotoPath = "dummy")
//       : (studentPhotoPath = studentPhotoRef.current?.value);
//     event.preventDefault();
//     if (!schoolNameRef.current?.value) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         schoolNameError: "Please select School/Institute name",
//       }));
//     }
//     if (!addressRef.current?.value) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         addressError: "Please Enter Valid Address",
//       }));
//     }
//     if (!pincodeRef.current?.value) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         pincodeError: "Please Enter Valid Pincode",
//       }));
//     }
//     if (!cityInputRef.current?.value) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         cityError: "Please Enter Valid City",
//       }));
//     }
//     if (!stateInputRef.current?.value) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         stateError: "Please Enter Valid State",
//       }));
//     }
//     if (!areaInputRef.current?.value) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         areaError: "Please Enter Valid Area",
//       }));
//     }
//     if (!/^[a-zA-Z ]{1,15}$/.test(studentFirstNameRef.current?.value)) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         studentFirstNameError: "Please Enter Valid First name",
//       }));
//     }
//     if (!/^[a-zA-Z ]{1,15}$/.test(studentLastNameRef.current?.value)) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         studentLastNameError: "Please Enter Valid Last name",
//       }));
//     }
//     if (!/^[a-zA-Z0-9 ]{1,15}$/.test(studentClassRef.current?.value)) {
//       valid = false;
//       setError((prev) => ({
//         ...prev,
//         studentClassError: "Please Enter Valid class",
//       }));
//     }

//     if (type === "Student") {
//       if (!/^[a-zA-Z ]{1,15}$/.test(parentFirstNameRef.current?.value)) {
//         valid = false;
//         setError((prev) => ({
//           ...prev,
//           parentFirstNameError: "Please Enter Valid First name ",
//         }));
//       }
//       if (!/^[a-zA-Z ]{1,15}$/.test(parentLastNameRef.current?.value)) {
//         valid = false;
//         setError((prev) => ({
//           ...prev,
//           parentLastNameError: "Please Enter Valid Last name",
//         }));
//       }
//       if (!/^[0]?[789]\d{9}$/.test(parentMobileNumberRef.current?.value)) {
//         valid = false;
//         setError((prev) => ({
//           ...prev,
//           parentMobileNumberError: "Please Enter valid Mobile number",
//         }));
//       }
//       if (
//         !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(
//           parentEmailRef.current?.value
//         )
//       ) {
//         valid = false;
//         setError((prev) => ({
//           ...prev,
//           parentEmailError: "Please Enter Valid Email",
//         }));
//       }
//     }
//     if (valid) {
//       let element = document.getElementsByClassName("header")[0];
//       element?.scrollIntoView({ behavior: "smooth", block: "end" });
//       setFormIsValid(true);
//       setError(false);
//     }
//   };

//   const submitCLicked = () => {
//     if (!staffImg) {
//       alert("Please upload the photo first.");
//       return;
//     }
//     setMyImg(false);
//   };

//   const handleChange = (event) => {
//     setType(event.target?.value);
//   };

//   return (
//     <Box sx={{ p: 3, maxWidth: "1400px", margin: "0 auto" }}>
//       {isLoading && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(255,255,255,0.7)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <img src={loadingGif} style={{ height: "100px" }} />
//         </Box>
//       )}

//       <Typography
//         variant="h5"
//         component="h3"
//         gutterBottom
//         // align="center"
//         sx={{
//           fontWeight: 700,
//           color: "black",
//           textTransform: "uppercase",
//           letterSpacing: "1px",
//         }}
//       >
//         {type === "Student" ? "Student Registration" : "Staff Registration"}
//       </Typography>
//       {/* </StyledPaper> */}

//       <form ref={formRef} onSubmit={submitCLickHandler} autoComplete="off">
//         <Grid container spacing={4}>
//           {/* Left Side - Form Fields */}
//           <Grid item xs={12} md={6}>
//             <StyledPaper elevation={3}>
//               <Box sx={{ mb: 4 }}>
//                 {showRadioButtons ? (
//                   <RadioGroup
//                     row
//                     aria-label="shuttleFor"
//                     name="shuttleFor"
//                     value={type}
//                     onChange={handleChange}
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-around",
//                       mb: 3,
//                       p: 2,
//                       backgroundColor: "#f5f7fa",
//                       borderRadius: "8px",
//                     }}
//                   >
//                     <FormControlLabel
//                       value="Student"
//                       control={<Radio color="primary" />}
//                       label={
//                         <Typography variant="body1" fontWeight="500">
//                           Student
//                         </Typography>
//                       }
//                     />
//                     <FormControlLabel
//                       value="Employee"
//                       control={<Radio color="primary" />}
//                       label={
//                         <Typography variant="body1" fontWeight="500">
//                           Employee
//                         </Typography>
//                       }
//                     />
//                   </RadioGroup>
//                 ) : (
//                   <Box
//                     sx={{
//                       p: 2,
//                       backgroundColor: "#f5f7fa",
//                       borderRadius: "8px",
//                       mb: 3,
//                     }}
//                   >
//                     <FormControlLabel
//                       value={type}
//                       control={<Radio checked color="primary" />}
//                       label={
//                         <Typography variant="body1" fontWeight="500">
//                           {type}
//                         </Typography>
//                       }
//                     />
//                   </Box>
//                 )}

//                 <SectionHeader variant="h6">
//                   {type === "Student"
//                     ? "School / Institute Detail"
//                     : "Corporate Details"}
//                 </SectionHeader>

//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Corporate Name"
//                       variant="standard"
//                       value={corpName}
//                       inputRef={schoolNameRef}
//                       disabled
//                       sx={{ mb: 2 }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth variant="standard" sx={{ mb: 2 }}>
//                       <InputLabel>Department</InputLabel>
//                       <Select
//                         value={selectedDepartment?.corporateID || ""}
//                         onChange={(e) => {
//                           const selected = departmentList.find(
//                             (dept) => dept.corporateID === e.target.value
//                           );
//                           setSelectedDepartment(selected || null);
//                         }}
//                         label="Department"
//                       >
//                         <MenuItem value="">Select Department</MenuItem>
//                         {departmentList?.map((dept) => (
//                           <MenuItem
//                             key={dept.corporateID}
//                             value={dept.corporateID}
//                           >
//                             {dept.name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Box sx={{ mb: 4 }}>
//                 <SectionHeader variant="h6">
//                   {(type === "Student" ? "Student " : "Staff ") + "Details"}
//                 </SectionHeader>

//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="First Name"
//                       variant="standard"
//                       inputRef={studentFirstNameRef}
//                       onChange={studentFirstNameChangeHandler}
//                       placeholder="Enter First Name"
//                       inputProps={{ maxLength: 20 }}
//                       value={studentFirstNameRef.current?.value || ""}
//                       sx={{ mb: 2 }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Last Name"
//                       variant="standard"
//                       inputRef={studentLastNameRef}
//                       onChange={studentLastNameChangeHandler}
//                       placeholder="Enter Last Name"
//                       inputProps={{ maxLength: 20 }}
//                       value={studentLastNameRef.current?.value || ""}
//                       sx={{ mb: 2 }}
//                     />
//                   </Grid>
//                 </Grid>

//                 <Grid container spacing={2} sx={{ mt: 1 }}>
//                   <Grid item xs={12} sm={6}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         mb: 2,
//                       }}
//                     >
//                       <input
//                         type="file"
//                         id="student-photo"
//                         ref={studentPhotoRef}
//                         onChange={studentPhotoChangeHandler}
//                         style={{ display: "none" }}
//                         accept="image/jpeg, image/jpg, image/png"
//                       />
//                       <label htmlFor="student-photo" style={{ flexGrow: 1 }}>
//                         <UploadButton
//                           variant="outlined"
//                           component="span"
//                           startIcon={<FiUpload />}
//                           fullWidth
//                           sx={{ height: "56px" }}
//                         >
//                           <Typography noWrap sx={{ maxWidth: "200px" }}>
//                             {img_placeHolder}
//                           </Typography>
//                         </UploadButton>
//                       </label>
//                       {val && (
//                         <IconButton
//                           onClick={editPageFileViewHandler}
//                           sx={{
//                             backgroundColor: "primary.main",
//                             color: "white",
//                             "&:hover": {
//                               backgroundColor: "primary.dark",
//                             },
//                           }}
//                         >
//                           <BsEyeFill />
//                         </IconButton>
//                       )}
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         mb: 2,
//                       }}
//                     >
//                       {type !== "Student" && (
//                         <FormControl variant="standard" sx={{ minWidth: 80 }}>
//                           <Select
//                             value={countryCode}
//                             onChange={(e) => setCountryCode(e.target.value)}
//                             style={{ width: "55px", marginTop: "16px" }}
//                           >
//                             <MenuItem value="91">+91</MenuItem>
//                             <MenuItem value="254">+254</MenuItem>
//                           </Select>
//                         </FormControl>
//                       )}
//                       <TextField
//                         fullWidth
//                         label={type === "Student" ? "Class" : "Mobile Number"}
//                         variant="standard"
//                         inputRef={studentClassRef}
//                         onChange={studentClassChangeHandler}
//                         value={studentClassRef.current?.value || ""}
//                         placeholder={
//                           type === "Student"
//                             ? "Enter Students class"
//                             : "Enter Mobile Number"
//                         }
//                         inputProps={{ maxLength: 30 }}
//                       />
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Box>

//               {type === "Student" && (
//                 <Box sx={{ mb: 4 }}>
//                   <SectionHeader variant="h6">Parent Details</SectionHeader>

//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="Parent's First Name"
//                         variant="standard"
//                         inputRef={parentFirstNameRef}
//                         onChange={ParentFirstNameChangeHandler}
//                         placeholder="Enter Parent's First Name"
//                         inputProps={{ maxLength: 20 }}
//                         value={parentFirstNameRef.current?.value || ""}
//                         sx={{ mb: 2 }}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="Parent's Last Name"
//                         variant="standard"
//                         inputRef={parentLastNameRef}
//                         onChange={parentLastNameChangeHanler}
//                         placeholder="Enter Parent's Last Name"
//                         inputProps={{ maxLength: 20 }}
//                         value={parentLastNameRef.current?.value || ""}
//                         sx={{ mb: 2 }}
//                       />
//                     </Grid>
//                   </Grid>

//                   <Grid container spacing={2} sx={{ mt: 1 }}>
//                     <Grid item xs={12} sm={6}>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1,
//                           mb: 2,
//                         }}
//                       >
//                         <FormControl variant="standard" sx={{ minWidth: 80 }}>
//                           <Select
//                             value={countryCode}
//                             onChange={(e) => setCountryCode(e.target.value)}
//                           >
//                             <MenuItem value="91">+91</MenuItem>
//                             <MenuItem value="254">+254</MenuItem>
//                           </Select>
//                         </FormControl>
//                         <TextField
//                           fullWidth
//                           label="Parent's Mobile Number"
//                           variant="standard"
//                           inputRef={parentMobileNumberRef}
//                           onChange={parentMobileChangeHandler}
//                           placeholder="Enter Parent's Mobile Number"
//                           value={parentMobileNumberRef.current?.value || ""}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         fullWidth
//                         label="Email Address"
//                         variant="standard"
//                         inputRef={parentEmailRef}
//                         onChange={parentEmailChangeHanlder}
//                         placeholder="Enter Email Address"
//                         inputProps={{ maxLength: 30 }}
//                         value={parentEmailRef.current?.value || ""}
//                         sx={{ mb: 2 }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//               )}

//               <Box sx={{ mb: 3 }}>
//                 <SectionHeader variant="h6">Address Details</SectionHeader>

//                 <TextField
//                   fullWidth
//                   label="Address Line"
//                   variant="standard"
//                   inputRef={addressRef}
//                   onChange={addressChangeHandler}
//                   placeholder="Enter Address Line"
//                   inputProps={{ maxLength: 100 }}
//                   value={addressRef.current?.value || ""}
//                   sx={{ mb: 3 }}
//                 />

//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Pincode"
//                       variant="standard"
//                       inputRef={pincodeRef}
//                       placeholder="Enter Pincode"
//                       onChange={pincodeChangeHandler}
//                       value={pincode}
//                       sx={{ mb: 2 }}
//                     />
//                     <Box
//                       sx={{
//                         maxHeight: "150px",
//                         overflowY: "auto",
//                         border:
//                           isNearbyAddresses?.length > 0
//                             ? "1px solid #e0e0e0"
//                             : "none",
//                         borderRadius: "4px",
//                         p: isNearbyAddresses?.length > 0 ? 1 : 0,
//                       }}
//                     >
//                       {isNearbyAddresses?.length > 0 &&
//                         isNearbyAddresses?.map((address, index) => (
//                           <Typography
//                             key={index}
//                             id={index + 11}
//                             onClick={nearbyAddressClickHandler}
//                             sx={{
//                               cursor: "pointer",
//                               p: 1.5,
//                               borderRadius: "4px",
//                               "&:hover": {
//                                 backgroundColor: "#f0f7ff",
//                                 color: "primary.main",
//                               },
//                               transition: "all 0.2s ease",
//                             }}
//                           >
//                             {address?.Name}
//                           </Typography>
//                         ))}
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Area"
//                       variant="standard"
//                       inputRef={areaInputRef}
//                       placeholder="Enter Area"
//                       onChange={areaChangeHandler}
//                       value={areaInputRef.current?.value || ""}
//                       sx={{ mb: 2 }}
//                     />
//                   </Grid>
//                 </Grid>

//                 <Grid container spacing={2} sx={{ mt: 1 }}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="City"
//                       variant="standard"
//                       inputRef={cityInputRef}
//                       placeholder="Enter City"
//                       onChange={cityChangeHandler}
//                       value={cityInputRef.current?.value || ""}
//                       sx={{ mb: 2 }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="State"
//                       variant="standard"
//                       inputRef={stateInputRef}
//                       placeholder="Enter State"
//                       onChange={stateChangeHandler}
//                       value={stateInputRef.current?.value || ""}
//                       sx={{ mb: 2 }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
//                 <FormButton
//                   type="submit"
//                   variant="contained"
//                   // color="primary"
//                   sx={{
//                     backgroundColor: littleGreen,
//                     color: "white",
//                     width: "100px",
//                   }}
//                   fullWidth
//                   // size="small"
//                 >
//                   Submit
//                 </FormButton>
//                 <FormButton
//                   type="button"
//                   variant="outlined"
//                   sx={{
//                     width: "100px",
//                     backgroundColor: littleYellow,
//                     color: "black",
//                     "&:hover": {
//                       backgroundColor: "#FDFD96",
//                       color: "black",
//                     },
//                   }}
//                   fullWidth
//                   // size="small"
//                   onClick={resetClickHandler}
//                 >
//                   Reset
//                 </FormButton>
//               </Box>
//             </StyledPaper>
//           </Grid>

//           {/* Right Side - Student Address */}
//           <Grid item xs={12} md={6}>
//             <StyledPaper elevation={3} sx={{ height: "100%" }}>
//               <StudentAddress
//                 stops={stops}
//                 addressEntered={getAddress}
//                 type={type}
//                 edit={edit}
//                 riderData={riderData}
//                 corpName={corpName}
//               />
//             </StyledPaper>
//           </Grid>
//         </Grid>
//       </form>

//       <Box sx={{ mt: 4, textAlign: "center" }}>
//         <Typography variant="body2" color="text.secondary">
//           <span style={{ fontSize: "13px" }}>&#169;</span>
//           <span> {new Date().getFullYear()} </span>
//           <span style={{ fontWeight: "bold", color: "primary.main" }}>
//             Little
//           </span>
//           <span> - All Rights Reserved</span>
//         </Typography>
//       </Box>

//       {formIsValid && (
//         <Modal
//           corpId={corpId}
//           selectedDepartment={selectedDepartment}
//           corpName={corpName}
//           type={type}
//           myOriginalFile={staffImg}
//           pickupLatLng={pickupLatLng}
//           dropLatLng={dropLatLng}
//           address={addressRef.current?.value}
//           pickupStop={studentpickupAddress}
//           dropStop={studentdropAddress}
//           studentPhoto={staffImg}
//           schoolname={schoolNameRef.current?.value}
//           studentfirstname={studentFirstNameRef.current?.value}
//           studentlastname={studentLastNameRef.current?.value}
//           studentclass={studentClassRef.current?.value}
//           parentfirstname={parentFirstNameRef?.current?.value}
//           parentlastname={parentLastNameRef?.current?.value}
//           parentmobilenumber={parentMobileNumberRef?.current?.value}
//           parentemailaddress={parentEmailRef?.current?.value}
//           pincode={pincodeRef.current?.value}
//           area={areaInputRef.current?.value}
//           city={cityInputRef.current?.value}
//           state={stateInputRef.current?.value}
//           closeCLickHandler={() => setFormIsValid(false)}
//           countryCode={countryCode}
//         />
//       )}
//     </Box>
//   );
// }

// export default App;

import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  styled,
} from "@mui/material";
import { FiUpload } from "react-icons/fi";
import { BsEyeFill } from "react-icons/bs";

import StudentAddress from "./StudentAddress";
import useHttp from "../../Hooks/use-http";
import loadingGif from "./loading-gif.gif";
import Modal from "./ReviewPage/ReviewPageIndex";
import { littleGreen, littleYellow } from "../CommonComponent/DefineColors";

// Styled Components
// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   borderRadius: "10px",
//   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//   background: "#ffffff",
// }));
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  background: "#ffffff",
  height: "calc(100vh - 100px)", // Fixed height with space for header
  // overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  // "&::-webkit-scrollbar-track": {
  //   background: "#f1f1f1",
  //   borderRadius: "10px",
  // },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "10px",
    "&:hover": {
      background: "#555",
    },
  },
}));

const SectionHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  fontSize: "1rem",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    bottom: -8,
    left: 0,
    width: "50px",
    height: "3px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "3px",
  },
}));

const FormButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: "6px",
  fontWeight: 600,
  fontSize: "0.875rem",
}));

// Add scroll indicator at the bottom
const ScrollIndicator = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "30px",
  background:
    "linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  // "&:after": {
  //   content: '"Scroll for more"',
  //   fontSize: "0.75rem",
  //   color: theme.palette.text.secondary,
  //   marginBottom: "5px",
  // },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  border: `1px dashed ${theme.palette.primary.main}`,
  backgroundColor: "rgba(25, 118, 210, 0.04)",
  "&:hover": {
    backgroundColor: "rgba(25, 118, 210, 0.08)",
  },
}));

const defaultState = {
  schoolNameError: "",
  studentFirstNameError: "",
  studentLastNameError: "",
  studentClassError: "",
  studentPhotoError: "",
  parentFirstNameError: "",
  parentLastNameError: "",
  parentMobileNumberError: "",
  parentEmailError: "",
  addressError: "",
  pickupError: "",
  pincodeError: "",
  areaError: "",
  cityError: "",
  stateError: "",
};

function App() {
  const formRef = useRef();
  const studentPhotoRef = useRef();
  const { isLoading, sendRequest } = useHttp();

  const [error, setError] = useState(defaultState);
  const [formIsValid, setFormIsValid] = useState(false);
  const [stops, setStops] = useState([]);
  const [isNearbyAddresses, setIsNearbyAddresses] = useState([]);
  const [isPincodeChanged, setIsPincodeChanged] = useState(false);
  const [countryCode, setCountryCode] = useState("91");
  const [type, setType] = useState("Employee");
  const [showRadioButtons, setShowRadioButtons] = useState(true);
  const [departmentList, setDepartmentList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({
    name: "",
    corporateID: "",
  });
  const [corpName, setCorpName] = useState("");
  const [corpId, setCorpId] = useState("");
  const [studentpickupAddress, setStudentpickupAddress] = useState("");
  const [studentdropAddress, setStudentdropAddress] = useState("");
  const [pickupLatLng, setPickupLatLng] = useState(null);
  const [dropLatLng, setDropLatLng] = useState(null);
  const [staffImg, setStaffImg] = useState("");
  const [imgPlaceholder, setImgPlaceholder] = useState("Profile Photo");
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [addressValid, setAddressValid] = useState(false);
  const [isStaffDetailApiCall, setIsStaffDetailApiCall] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [riderData, setRiderData] = useState(null);
  const [initialFormData, setInitialFormData] = useState(null);

  // Add this effect to detect edit mode
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const editParam = searchParams.get("edit");
    if (editParam) {
      setEditMode(true);
      fetchRiderDetails(editParam);
    }
  }, []);

  // Add this function to fetch rider details
  const fetchRiderDetails = (mobileNumber) => {
    sendRequest(
      {
        url: "/student/getstaffdetails",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          mobileNumber: mobileNumber,
        },
      },
      (data) => {
        setRiderData(data.Staffdetails);
        populateFormData(data.Staffdetails);
      }
    );
  };

  // Add this function to populate form data
  const populateFormData = (riderData) => {
    const addressParts = riderData?.Address?.split(", ") || [];
    const Pin = addressParts[addressParts.length - 1] || "";
    const State = addressParts[addressParts.length - 2] || "";
    const City = addressParts[addressParts.length - 3] || "";
    const Area =
      addressParts.slice(0, addressParts.length - 3).join(", ") || "";

    const otherDetails = riderData?.OtherDetails || {};

    const initialData = {
      firstName: riderData?.FirstName || "",
      lastName: riderData?.LastName || "",
      class:
        otherDetails.Class ||
        (type === "Student" ? "" : riderData?.MobileNumber?.slice(2) || ""),
      parentFirstName: otherDetails.ParentFirstName || "",
      parentLastName: otherDetails.ParentLastName || "",
      parentMobile:
        otherDetails.ParentsMobileNumber ||
        riderData?.MobileNumber?.slice(2) ||
        "",
      parentEmail: otherDetails.ParentEmailAddress || "",
      address: riderData?.Address || "",
      pincode: otherDetails.Pincode || Pin || "",
      area: otherDetails.Area || Area || "",
      city: otherDetails.City || City || "",
      state: otherDetails.State || State || "",
    };
    selectedDepartment.name = riderData?.departmentName || "";
    selectedDepartment.corporateID = riderData?.departmentID || "";

    setInitialFormData(initialData);
    setFormData(initialData);

    if (riderData?.PickupLL) {
      const [lat, lng] = riderData.PickupLL.split(",").map(Number);
      setPickupLatLng({ lat, lng });
      setStudentpickupAddress(riderData?.PickupPoint || "");
    }

    if (riderData?.DropLL) {
      const [lat, lng] = riderData.DropLL.split(",").map(Number);
      setDropLatLng({ lat, lng });
      setStudentdropAddress(riderData?.DropPoint || "");
    }

    if (riderData?.RiderImage) {
      setStaffImg(riderData.RiderImage);
      setImgPlaceholder("Profile photo loaded");
    }
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    class: "",
    parentFirstName: "",
    parentLastName: "",
    parentMobile: "",
    parentEmail: "",
    address: "",
    // pincode: "",
    // area: "",
    // city: "",
    // state: "",
  });

  // Track scroll position to hide indicator when user scrolls
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;
    setShowScrollIndicator(!isNearBottom);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setCorpName(searchParams.get("name") || "");
    setCorpId(searchParams.get("corpId") || "");
  }, []);

  useEffect(() => {
    if (corpId) {
      sendRequest(
        {
          url: "/corporate",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID: corpId,
              },
            },
          },
        },
        corporateStopDetails
      );
    }
  }, [corpId, sendRequest]);

  useEffect(() => {
    if (isPincodeChanged) {
      fetch(`https://api.postalpincode.in/pincode/${isPincodeChanged}`)
        .then((response) => response.json())
        .then((result) => {
          if (result[0]?.PostOffice) {
            setIsNearbyAddresses(result[0]?.PostOffice);
          } else {
            setIsNearbyAddresses([{ Name: "No nearby address found" }]);
          }
        })
        .catch((error) => console.log("error", error));
      setIsPincodeChanged(false);
    }
  }, [isPincodeChanged]);

  const corporateStopDetails = (data) => {
    let temp = [{ StopName: "Custom" }];
    if (data.ShuttleStopList) {
      const activeStops = data.ShuttleStopList.filter(
        (st) => st.IsActive === true
      );
      temp.push(...activeStops);
      setStops(temp);
    }
    setDepartmentList(data?.departmentLists || []);

    if (data.ShuttleFor) {
      const roles = data.ShuttleFor.split(",").map((role) =>
        role.trim().toLowerCase()
      );
      if (roles.length === 1) {
        setType(roles[0] === "student" ? "Student" : "Employee");
        setShowRadioButtons(false);
      } else {
        setType("Employee");
        setShowRadioButtons(true);
      }
    } else {
      setType("Employee");
      setShowRadioButtons(true);
      setIsStaffDetailApiCall(true);
    }
  };

  const nearbyAddressClickHandler = (e) => {
    const selectedAddress = isNearbyAddresses[e.target.id - 11];
    setFormData((prev) => ({
      ...prev,
      city: selectedAddress.District,
      state: selectedAddress.Circle,
      area: selectedAddress.Name,
    }));
    setIsNearbyAddresses([]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (error[`${name}Error`]) {
      setError((prev) => ({
        ...prev,
        [`${name}Error`]: "",
      }));
    }
  };

  const pincodeChangeHandler = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only numbers
    setFormData((prev) => ({ ...prev, pincode: value }));
    if (value.length === 6) {
      setIsPincodeChanged(value);
      setError((prev) => ({ ...prev, pincodeError: "" }));
    }
  };

  const studentPhotoChangeHandler = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validTypes.includes(file.type)) {
      setError((prev) => ({
        ...prev,
        studentPhotoError: "Only JPG or PNG allowed.",
      }));
      return;
    }

    setImgPlaceholder(file.name);
    setError((prev) => ({ ...prev, studentPhotoError: "" }));

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    formDataUpload.append("fileName", file.name);
    formDataUpload.append("folderName", "rider");
    formDataUpload.append("uniqueID", formData.firstName);
    formDataUpload.append("documentID", "logo");
    formDataUpload.append(
      "fileExtension",
      file.name.split(".").pop().toLowerCase()
    );

    try {
      const response = await fetch(
        "https://littleinfinity.in:4001/documentfileupload",
        {
          method: "POST",
          body: formDataUpload,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStaffImg(data?.data);
        alert("Picture uploaded successfully!");
      } else {
        console.error("Upload failed:", data.message);
        setError((prev) => ({
          ...prev,
          studentPhotoError: "Upload failed. Try again.",
        }));
      }
    } catch (err) {
      console.error("Upload error:", err);
      setError((prev) => ({
        ...prev,
        studentPhotoError: "Upload error. Try again.",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = { ...defaultState };
    let isValid = true;

    if (!formData.firstName.trim()) {
      newErrors.studentFirstNameError = "First name is required";
      isValid = false;
    } else if (!/^[a-zA-Z ]{1,15}$/.test(formData.firstName)) {
      newErrors.studentFirstNameError = "Invalid first name";
      isValid = false;
    }

    if (!formData.lastName.trim()) {
      newErrors.studentLastNameError = "Last name is required";
      isValid = false;
    } else if (!/^[a-zA-Z ]{1,15}$/.test(formData.lastName)) {
      newErrors.studentLastNameError = "Invalid last name";
      isValid = false;
    }

    if (!addressValid) {
      newErrors.pickupError = "Please select valid pickup and drop addresses";
      isValid = false;
      setAddressValid(false);
    }

    if (!formData.class.trim()) {
      newErrors.studentClassError =
        type === "Student" ? "Class is required" : "Mobile number is required";
      isValid = false;
    }

    if (type === "Student") {
      if (!formData.parentFirstName.trim()) {
        newErrors.parentFirstNameError = "Parent first name is required";
        isValid = false;
      }

      if (!formData.parentLastName.trim()) {
        newErrors.parentLastNameError = "Parent last name is required";
        isValid = false;
      }

      if (!formData.parentMobile.trim()) {
        newErrors.parentMobileNumberError = "Parent mobile is required";
        isValid = false;
      } else if (!/^[0]?[789]\d{9}$/.test(formData.parentMobile)) {
        newErrors.parentMobileNumberError = "Invalid mobile number";
        isValid = false;
      }

      if (!formData.parentEmail.trim()) {
        newErrors.parentEmailError = "Parent email is required";
        isValid = false;
      } else if (
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(
          formData.parentEmail
        )
      ) {
        newErrors.parentEmailError = "Invalid email address";
        isValid = false;
      }
    }

    if (!formData.address.trim()) {
      newErrors.addressError = "Address is required";
      isValid = false;
    }

    // if (!formData.pincode.trim()) {
    //   newErrors.pincodeError = "Pincode is required";
    //   isValid = false;
    // } else if (formData.pincode.length !== 6) {
    //   newErrors.pincodeError = "Pincode must be 6 digits";
    //   isValid = false;
    // }

    // if (!formData.area.trim()) {
    //   newErrors.areaError = "Area is required";
    //   isValid = false;
    // }

    // if (!formData.city.trim()) {
    //   newErrors.cityError = "City is required";
    //   isValid = false;
    // }

    // if (!formData.state.trim()) {
    //   newErrors.stateError = "State is required";
    //   isValid = false;
    // }

    setError(newErrors);
    return isValid;
  };

  const submitCLickHandler = (event) => {
    event.preventDefault();
    if (validateForm()) {
      setFormIsValid(true);
    }
  };

  const resetClickHandler = () => {
    setFormData({
      firstName: "",
      lastName: "",
      class: "",
      parentFirstName: "",
      parentLastName: "",
      parentMobile: "",
      parentEmail: "",
      address: "",
      // pincode: "",
      // area: "",
      // city: "",
      // state: "",
    });
    setError(defaultState);
    setImgPlaceholder("Profile Photo");
    setStaffImg("");
  };

  const getAddress = useCallback((type, addressValue, lat, lng) => {
    if (type === "pickup") {
      setPickupLatLng({ lat: +lat, lng: +lng });
      setStudentpickupAddress(addressValue);
    } else {
      setDropLatLng({ lat: +lat, lng: +lng });
      setStudentdropAddress(addressValue);
    }
  }, []);

  return (
    <Box sx={{ p: 0, maxWidth: "100%", marginTop: "-16px" }}>
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            marginTop: "-16px",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img src={loadingGif} style={{ height: "80px" }} alt="Loading..." />
        </Box>
      )}

      <form ref={formRef} onSubmit={submitCLickHandler}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          {/* Left Side - Form Fields */}
          <Grid item xs={12} md={6}>
            <StyledPaper elevation={3} onScroll={handleScroll}>
              {showScrollIndicator && <ScrollIndicator />}
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, fontSize: "16px" }}>
                {type === "Student" ? "Student Registration" : "Staff Registration"}
              </Typography>
              {showRadioButtons && (
                <RadioGroup
                  row
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  sx={{ mb: 2, justifyContent: "space-around" }}
                >
                  <FormControlLabel
                    value="Student"
                    control={<Radio size="small" />}
                    label="Student"
                  />
                  <FormControlLabel
                    value="Employee"
                    control={<Radio size="small" />}
                    label="Employee"
                  />
                </RadioGroup>
              )}

              <SectionHeader>
                {type === "Student" ? "School Details" : "Corporate Details"}
              </SectionHeader>
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", alignItems: "flex-end" }}
              >
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Corporate Name"
                    variant="standard"
                    value={corpName}
                    disabled
                    size="small"
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    variant="standard"
                    size="small"
                    sx={{ mb: 2 }}
                  >
                    <InputLabel>Department</InputLabel>
                    <Select
                      value={selectedDepartment.corporateID || ""}
                      // onChange={(e) => setSelectedDepartment(e.target.value)}
                      onChange={(e) => {
                        const selectedDept = departmentList.find(
                          (dept) => dept.corporateID === e.target.value
                        );
                        setSelectedDepartment({
                          name: selectedDept?.name || "",
                          corporateID: e.target.value,
                        });
                      }}
                      label="Department"
                    >
                      <MenuItem value="">Select Department</MenuItem>
                      {departmentList.map((dept) => (
                        <MenuItem
                          key={dept.corporateID}
                          value={dept.corporateID}
                        >
                          {dept.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <SectionHeader>
                {type === "Student" ? "Student Details" : "Staff Details"}
              </SectionHeader>

              {/* image and name =============================================== */}
              {/* <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="First Name"
                    name="firstName"
                    variant="standard"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    size="small"
                    error={!!error.studentFirstNameError}
                    helperText={error.studentFirstNameError}
                    sx={{ mb: 1 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    name="lastName"
                    variant="standard"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    size="small"
                    error={!!error.studentLastNameError}
                    helperText={error.studentLastNameError}
                    sx={{ mb: 1 }}
                  />
                </Grid>
              </Grid> */}

              {/* <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <input
                  type="file"
                  id="student-photo"
                  ref={studentPhotoRef}
                  onChange={studentPhotoChangeHandler}
                  style={{ display: "none" }}
                  accept="image/jpeg, image/jpg, image/png"
                />
                <label htmlFor="student-photo" style={{ flexGrow: 1 }}>
                  <UploadButton
                    variant="outlined"
                    component="span"
                    startIcon={<FiUpload />}
                    fullWidth
                    sx={{ height: "40px" }}
                  >
                    <Typography noWrap sx={{ maxWidth: "200px" }}>
                    
                      {staffImg ? "Photo uploaded" : imgPlaceholder}
                    </Typography>
                  </UploadButton>
                </label>
                {staffImg && (
                  <IconButton
                    onClick={() => window.open(staffImg, "_blank")}
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                    }}
                  >
                    <BsEyeFill />
                  </IconButton>
                )}
              </Box> */}

              {/* <Grid container spacing={2} sx={{ alignItems: "center", mb: 2 }}>
              
                <Grid item xs={12} sm="auto">
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <input
                      type="file"
                      id="student-photo"
                      ref={studentPhotoRef}
                      onChange={studentPhotoChangeHandler}
                      style={{ display: "none" }}
                      accept="image/jpeg, image/jpg, image/png"
                    />
                    <label htmlFor="student-photo">
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          border: "1px dashed #ccc",
                          cursor: "pointer",
                          "&:hover": {
                            borderColor: "primary.main",
                            backgroundColor: "rgba(25, 118, 210, 0.04)",
                          },
                        }}
                      >
                        {staffImg ? (
                          <img
                            src={staffImg}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FiUpload size={24} color="#666" />
                        )}
                      </Box>
                    </label>
                  </Box>
                </Grid>

                
                <Grid item xs={12} sm>
                  <Grid container spacing={1} sx={{ height: "100%" }}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="First Name"
                        name="firstName"
                        variant="standard"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        size="small"
                        error={!!error.studentFirstNameError}
                        helperText={error.studentFirstNameError}
                        sx={{
                          "& .MuiInput-root": {
                            marginTop: "0 !important",
                            paddingTop: "8px",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Last Name"
                        name="lastName"
                        variant="standard"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        size="small"
                        error={!!error.studentLastNameError}
                        helperText={error.studentLastNameError}
                        sx={{
                          "& .MuiInput-root": {
                            marginTop: "0 !important",
                            paddingTop: "8px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                {type !== "Student" && (
                  <FormControl
                    variant="standard"
                    size="small"
                    sx={{ minWidth: 80 }}
                  >
                    <Select
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      <MenuItem value="91">+91</MenuItem>
                      <MenuItem value="254">+254</MenuItem>
                    </Select>
                  </FormControl>
                )}
                <TextField
                  fullWidth
                  label={type === "Student" ? "Class" : "Mobile Number"}
                  name="class"
                  variant="standard"
                  value={formData.class}
                  onChange={handleInputChange}
                  size="small"
                  error={!!error.studentClassError}
                  helperText={error.studentClassError}
                  disabled={editMode && type !== "Student"}
                />
              </Box> */}

              <Grid
                container
                spacing={2}
                sx={{ alignItems: "flex-start", mb: 2 }}
              >
                {/* Image Upload Circle - Left Side */}
                <Grid item xs={12} sm="auto">
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <input
                      type="file"
                      id="student-photo"
                      ref={studentPhotoRef}
                      onChange={studentPhotoChangeHandler}
                      style={{ display: "none" }}
                      accept="image/jpeg, image/jpg, image/png"
                    />
                    <label htmlFor="student-photo">
                      <Box
                        sx={{
                          width: 100,
                          height: 100,
                          borderRadius: "50%",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          border: "1px dashed #ccc",
                          mt: 1,
                          cursor: "pointer",
                          "&:hover": {
                            borderColor: "primary.main",
                            backgroundColor: "rgba(25, 118, 210, 0.04)",
                          },
                        }}
                      >
                        {staffImg ? (
                          <img
                            src={staffImg}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FiUpload size={24} color="#666" />
                        )}
                      </Box>
                    </label>
                  </Box>
                </Grid>

                {/* Right Side Content */}
                <Grid item xs={12} sm>
                  <Grid container spacing={1}>
                    {/* First Name - Last Name Stacked */}
                    <Grid
                      container
                      spacing={2}
                      sx={{ display: "flex", alignItems: "flex-end" }}
                    >
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="First Name"
                          name="firstName"
                          variant="standard"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          size="small"
                          error={!!error.studentFirstNameError}
                          helperText={error.studentFirstNameError}
                          sx={{ mb: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                        <TextField
                          fullWidth
                          label="Last Name"
                          name="lastName"
                          variant="standard"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          size="small"
                          error={!!error.studentLastNameError}
                          helperText={error.studentLastNameError}
                        />
                      </Grid>
                    </Grid>

                    {/* Country Code + Mobile Number - Compact Row */}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mt: 1,
                        }}
                      >
                        {type !== "Student" && (
                          <FormControl
                            variant="standard"
                            size="small"
                            sx={{ minWidth: 80 }}
                          >
                            <Select
                              value={countryCode}
                              onChange={(e) => setCountryCode(e.target.value)}
                            >
                              <MenuItem value="91">+91</MenuItem>
                              <MenuItem value="254">+254</MenuItem>
                            </Select>
                          </FormControl>
                        )}

                        <TextField
                          fullWidth
                          label={type === "Student" ? "Class" : "Mobile Number"}
                          name="class"
                          variant="standard"
                          value={formData.class}
                          onChange={handleInputChange}
                          sx={{ mb: 2 }}
                          size="small"
                          error={!!error.studentClassError}
                          helperText={error.studentClassError}
                          disabled={editMode && type !== "Student"}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <TextField
                fullWidth
                label="Address"
                name="address"
                variant="standard"
                value={formData.address}
                onChange={handleInputChange}
                size="small"
                error={!!error.addressError}
                helperText={error.addressError}
                sx={{ mb: 2 }}
              />
              {/* <Box sx={{ minHeight: "24px", mb: 1 }}>
                {error.addressError && (
                  <Typography color="error" variant="caption">
                    {error.addressError}
                  </Typography>
                )}
              </Box> */}
              {/* ============================================= */}
              {type === "Student" && (
                <>
                  <SectionHeader>Parent Details</SectionHeader>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Parent's First Name"
                        name="parentFirstName"
                        variant="standard"
                        value={formData.parentFirstName}
                        onChange={handleInputChange}
                        size="small"
                        error={!!error.parentFirstNameError}
                        helperText={error.parentFirstNameError}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Parent's Last Name"
                        name="parentLastName"
                        variant="standard"
                        value={formData.parentLastName}
                        onChange={handleInputChange}
                        size="small"
                        error={!!error.parentLastNameError}
                        helperText={error.parentLastNameError}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                  </Grid>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <FormControl
                      variant="standard"
                      size="small"
                      sx={{ minWidth: 80 }}
                    >
                      <Select
                        value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}
                      >
                        <MenuItem value="91">+91</MenuItem>
                        <MenuItem value="254">+254</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      fullWidth
                      sx={{ mb: 2 }}
                      label="Parent's Mobile"
                      name="parentMobile"
                      variant="standard"
                      value={formData.parentMobile}
                      onChange={handleInputChange}
                      size="small"
                      error={!!error.parentMobileNumberError}
                      helperText={error.parentMobileNumberError}
                    />
                  </Box>

                  {/* <TextField
                    fullWidth
                    label="Parent's Email"
                    name="parentEmail"
                    variant="standard"
                    value={formData.parentEmail}
                    onChange={handleInputChange}
                    size="small"
                    error={!!error.parentEmailError}
                    helperText={error.parentEmailError}
                    sx={{ mb: 2 }}
                  /> */}
                </>
              )}

              <Box
                sx={{
                  // display: "flex",
                  // gap: 1,
                  // p: 2,
                  // justifyContent: "flex-end",
                  mt: "auto", // Pushes to bottom
                  display: "flex",
                  gap: 1,
                  p: 2,
                  justifyContent: "flex-end",
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: "background.paper",
                  // zIndex: 1,
                }}
              >
                {/* <FormButton
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: littleGreen,
                    color: "white",
                    width: "120px",
                  }}
                  color="primary"
                  fullWidth
                >
                  Submit
                </FormButton> */}

                <Button
                  variant="contained"
                  onClick={resetClickHandler}
                  style={{
                    backgroundColor: "#EDBD1A",
                    color: "black",
                    marginLeft: "10px",
                    transition: "background-color 0.3s",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "red";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "orange";
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  // onClick={handleSubmit}
                >
                  Submit
                </Button>
                {/* <FormButton
                  type="button"
                  variant="outlined"
                  sx={{
                    width: "120px",
                    backgroundColor: littleYellow,
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#FDFD96",
                      color: "black",
                    },
                  }}
                  fullWidth
                  onClick={resetClickHandler}
                >
                  Reset
                </FormButton> */}
              </Box>
            </StyledPaper>
          </Grid>

          {/* Right Side - Student Address */}
          <Grid item xs={12} md={6} style={{ height: "90%" }}>
            <StyledPaper elevation={3}>
              {/* <div
              style={{
                height: "90%",
                display: "flex",
                flexDirection: "column",
              }}
            > */}
              <StudentAddress
                style={{ flex: 1 }}
                stops={stops}
                addressEntered={getAddress}
                type={type}
                corpName={corpName}
                onValidationChange={(isValid) => setAddressValid(isValid)}
                errorMessage={error.pickupError}
                formData={formData}
                errorHandler={error}
                setPickupLatLng={setPickupLatLng}
                setDropLatLng={setDropLatLng}
                // errorHelperText={error}
                edit={editMode}
                isNearByAddresses={isNearbyAddresses}
                riderData={riderData}
                handleInputChange={handleInputChange}
                nearbyAddressClickHandler={nearbyAddressClickHandler}
                pincodeChangeHandler={pincodeChangeHandler}
              />
              {/* </div> */}
            </StyledPaper>
          </Grid>
        </Grid>
      </form>

      {formIsValid && (
        <Modal
          corpId={corpId}
          selectedDepartment={selectedDepartment}
          corpName={corpName}
          type={type}
          myOriginalFile={staffImg}
          pickupLatLng={pickupLatLng}
          dropLatLng={dropLatLng}
          address={formData.address}
          pickupStop={studentpickupAddress}
          dropStop={studentdropAddress}
          studentPhoto={staffImg}
          schoolname={corpName}
          studentfirstname={formData.firstName}
          studentlastname={formData.lastName}
          studentclass={formData.class}
          parentfirstname={formData.parentFirstName}
          parentlastname={formData.parentLastName}
          parentmobilenumber={formData.parentMobile}
          parentemailaddress={formData.parentEmail}
          pincode={formData.pincode}
          area={formData.area}
          city={formData.city}
          state={formData.state}
          closeCLickHandler={() => setFormIsValid(false)}
          countryCode={countryCode}
        />
      )}
    </Box>
  );
}

export default App;
